import Button from '@mui/material/Button';
import CustomTextArea from './CustomTextArea';
import CustomTextField from './CustomTextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Post } from '../services';
import { ToastContainer, toast } from 'react-toastify';
import beachVideo from '../assets/images/beach.mp4';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/styles/Home.scss';

const Home = () => {
  type Errors = {
    emailError: boolean;
  };

  type Inputs = {
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    companyName: string,
    comment: string
  };

  const [submitted, setSubmitted] = useState(false);

  const [errors, setErrors] = useState<Errors>({
    emailError: false
  });

  const [input, setInput] = useState<Inputs>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    companyName: '',
    comment: ''
  });

  const sendComment = async () => {
    const response = await Post('/api/sendComment', input);
    if (response.message) {
      setSubmitted(true);
      toast('You\'re comment has been sent!');
      return;
    }
  };

  function handleChange(event: any) {
    const name = event.target.name;
    const value = event.target.value;
    setInput((values) => ({ ...values, [name]: value }));
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (!input.email) {
      toast('Email is required');
      setErrors({
        emailError: true
      });
      return;
    }
    sendComment();
  };

  return (
    <div className="home">
      <header>
        <Typography variant={'h1'}>Amelia Wanowska</Typography>
      </header>
      <article>
        <Typography variant={'h2'}>Looking for Amelia Wanowska?</Typography>
        <p>To contact us, leave a comment below.</p>
        <form onSubmit={handleSubmit}>
          <fieldset className="outerFieldset">
            {submitted ? (
              <div>
                <p>Thank you, your comment has been submitted for review.</p>
              </div>
            ) : (
              <div>
                <CustomTextField
                  changeHandler={handleChange}
                  label={"First Name"}
                  name={"firstName"}
                />
                <CustomTextField
                  changeHandler={handleChange}
                  label={'Last Name'}
                  name={'lastName'}
                />
                <div>
                  <CustomTextField
                    changeHandler={handleChange}
                    label={'Email'}
                    name={'email'}
                    className={errors.emailError ? 'error' : ''}
                  />
                  <CustomTextField
                    changeHandler={handleChange}
                    label={'Phone'}
                    name={'phone'}
                  />                           
                </div>

                <div style={{ display: 'none' }} aria-hidden="true">
                  <label>If you are a human, leave this blank:</label>             
                  <input
                    type="text"
                    name="companyName"
                    onChange={handleChange}
                    tabIndex={-1}
                    autoComplete="off"
                  />
                </div>

                <CustomTextArea
                    changeHandler={handleChange}
                    label={'Comment'}
                    name={'comment'}    
                />                               
                <div>
                  <Button
                    type={'submit'}
                    variant="contained"
                  >
                    Send Comment
                  </Button>
                </div>
              </div>
            )}            

          </fieldset>
        </form>        
      </article>
      <footer>
          &copy; 2026 WanowskaAmelia
      </footer>
      <video autoPlay className="amelia-bg" loop muted>
          <source src={beachVideo} type="video/mp4" />
          Your browser does not support HTML5 video.
      </video>
      <ToastContainer />
    </div>
  );
};

export default Home;
